export default __webpack_public_path__ + "static/media/flaamorais.8d91435b.jpg";